import React, { Component } from "react";
// import { StyledBody, StyledModal, ChallengeInfo } from "./styles";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { ImageUrl } from "../../utils/constants";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { StyledBody, StyledModal } from "../ChallengeDashboardV2/TeamChallengeInvitePopup/styles";
import Spinner from "../common/Spinner";
import { DeleteInfo } from "./styles";
import { StyledInputPassword, StyledInputV2, Title } from "../CompanyDashBoardV2/styles";
import { fetchApi } from "../../utils/methods";
import { DeleteCompany } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { setCompany } from "../../redux/actions";

class DeleteCompanyPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmPopUp:false,
      password:null,
      isLoading:false
    };
  }

  onChangeInput = (e)=>{
    this.setState({password:e.target.value})
  }

  onSelect = (value) => {
    const {
      companies,
      setCompany,
      //   fetchDashBoardAPI,
      //   fetchFitnessAPI,
      //   fetchChampionAPI,
      //   fetchAdminAPI,
      //   companyBrandingCallBack,
    //   fetchCompanyInfo,
    } = this.props;
    const id = companies.filter((company) => company.id === value)[0]
      .id;
    const comapanyStartDate = companies.filter(
      (company) => company.id === value
    )[0].company_start_date;
    const biometricStatus = companies.filter(
      (company) => company.id === value
    )[0].show_biometric;
    const name = companies.filter((company) => company.id === value)[0].company_name;

    const selectedCompany = {
      id: id,
      name: name,
      companyStartDate: comapanyStartDate,
      showBiometricStatus: biometricStatus
    };
  
    localStorage.setItem('selectedCompany', JSON.stringify(selectedCompany));

    setCompany(id, value, comapanyStartDate, biometricStatus);
  };

  deleteCompany = async()=>{
    this.setState({isLoading:true});
    const{history,companyDetails} = this.props;
    const payload = { company_id: companyDetails.id,password: this.state.password}
    const res = await fetchApi(DeleteCompany, "POST",payload);
    if(res.data.message){
      toast.error(res.data.message);
      this.setState({isLoading:false});
    }else{
      this.onSelect(1)
      toast.success(res?.data[0]);
      history.push("/company/dashboard");
      this.setState({isLoading:false});
    }
  }

  confirmPopUp = ()=>{
    const { /*onYesClick,*/ onClose,companyDetails } = this.props;
    const {showConfirmPopUp, password,isLoading} = this.state;
    return (
      <StyledModal
        show={showConfirmPopUp}
        onHide={onClose}
        dialogClassName={"info-popup"}
        backdropClassName="drop-back"
      >
        <Modal.Header style={{display:"flex", justifyContent:"space-between", alignItems:"center",width:"100%",background:"#005C87"}}>
          <div>
            {" "}
            <span>Delete Company</span>
          </div>
          <div style={{cursor:"pointer"}}> <img src='/public/images/new_close_icon.png' style={{width:"18px", height:"18px"}}  onClick={onClose}/></div>
        </Modal.Header>
        <StyledBody>
          <DeleteInfo>
            <div>
              <img src={ImageUrl + '/' + companyDetails.image} style={{maxHeight:'160px',maxWidth:"440px",borderRadius:'6px'}}/>
            </div>
            <div>

              <Title margin="15px 0 15px 0">Enter super admin password to delete the company<span>*</span></Title>

              <StyledInputPassword
                bgColor="#F7F5EB80"
                pColor="#005C874D"
                border="1px solid #005C874D"
                color="#005C87"
                type="password"
              >
                <StyledInputV2
                  placeholder={("Enter Confirm Password")}
                  name="newCompanyConfirmPassword"
                  onChange={this.onChangeInput}
                  value={password}
                  maxLength="100"
                  bgColor="#F7F5EB80"
                  pColor="#005C874D"
                  border="1px solid #005C874D"
                  color="#005C87"
                  type="password"
                />
              </StyledInputPassword>

            </div>
            <div className="btns">
              <button style={{width:"100%",opacity:!password && "50%"}} className="btn1"  disabled={!password || isLoading} onClick={()=>!isLoading && this.deleteCompany()}>{isLoading ? <Spinner color={"white"}/> : "Confirm"}</button>
            </div>
          </DeleteInfo>
        </StyledBody>
      </StyledModal>
    );
    

  }

  render() {
    const { showModal, onClose,companyDetails } = this.props;
    const {showConfirmPopUp,isLoading} = this.state;
    return (
      <>
        {!showConfirmPopUp ? <StyledModal
          show={showModal}
          onHide={onClose}
          dialogClassName={"info-popup"}
          backdropClassName="drop-back"
        >
          <Modal.Header style={{background:"#005C87"}}>
            <div>
              {" "}
              <span>Delete Company</span>
            </div>
          </Modal.Header>
          <StyledBody>
            <DeleteInfo>
              <div>
                <img src={ImageUrl + '/' + companyDetails.image} style={{ maxHeight:'160px',maxWidth:"440px",borderRadius:'6px'}}/>
              </div>
              <div className="que" >Are you sure you want to delete  <span style={{fontFamily:"Rubik-Medium"}}>{companyDetails.name} </span>company?</div>
              <div className="note">{`Deleting this company will permanently remove all data, including users, challenges, and engagement history.`}</div>
              <div className="btns">
                <button className="btn1"  disabled={isLoading} onClick={()=>this.setState({showConfirmPopUp:true})}>{isLoading ? <Spinner color={"white"}/> : "Yes Delete!"}</button>
                <button className="btn2" onClick={()=>onClose()}>Cancel</button>
              </div>
            </DeleteInfo>
          </StyledBody>
        </StyledModal>:null}
        {showConfirmPopUp && this.confirmPopUp()}
      </>
    );
  }
}


DeleteCompanyPopUp.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  onNoClick:PropTypes.func,
  onYesClick:PropTypes.func,
  isLoading:PropTypes.bool,
  companyDetails:PropTypes.object,
  history:PropTypes.object,
  companies:PropTypes.array,
  setCompany:PropTypes.func
};

const mapStateToProps = (state) => ({
  companies: state.companyDashboard.companies,
});

const mapDispatchToProps = (dispatch) => ({
  setCompany: (id, name, companyStartDate, biometricStatus) => dispatch(setCompany(id, name, companyStartDate, biometricStatus)),
  //   fetchCompany: () => dispatch(getCompany()),
});


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeleteCompanyPopUp));

